<template>
  <!-- 购物车下单和直接下单共用一个页面 通过数据是否为多个来判断是否为购物车下单 -->
  <div class="goods-order-wrapper" v-show="token">
    <div class="address-area">
      <div class="no-address" v-if="!defaultAddress" @click="toAddress(true)">
        <span>新增收货地址</span>
        <img :src="rightIconTransSrc">
      </div>
      <div class="address" v-else @click="show=true" v-cloak>
        <div class="address-left">
          <div class="big-word">{{defaultAddress.real_name}} {{encodeTel}}</div>
          <div class="detail">{{longAddress}}</div>
        </div>
        <img :src="rightIconTransSrc" alt class="address-right">
      </div>
    </div>
    <div class="goods-area" v-if="data">
      <div class="each-goods" v-for="(item,index) in data" :key="index">
        <div class="goods-display">
          <div class="goods-left">
            <img :src="item.thumbnail" class="img-responsive">
          </div>
          <div class="goods-right">
            <div class="goods-inner-top" v-text="item.productName"></div>
            <div class="goods-inner-center" v-text="item.specsName"></div>
            <div class="goods-inner-bottom">
              <div class="price-wra">
                <div class="pr">x {{item.count}}</div>
                <van-stepper
                  v-if="isShoppingCart == 0"
                  v-model="item.count"
                  :max="item.stockNum === -1 ? undefined : item.stockNum"
                  :min="1"
                  integer
                />
                <div class="pl" v-if="isShoppingCart != 0">
                  ￥
                  <span class="price">{{item.salePrice | tofixed2}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="normal-row"
                    v-if="isShoppingCart == 0">
                    <div class="left">数量</div>
                   
        </div>-->

        <div
          class="normal-row"
          @click="openCouponModal(item,index)"
          v-if="item.couponList.length>0"
        >
          <div class="normal-row-left">优惠券</div>
          <div class="normal-row-right">
            <span
              class="coupon-price"
              v-if="item.currentDiscount"
            >-￥{{item.currentDiscount.toFixed(2)}}</span>
            <span
              v-else
              class="keyong-coupon-tag"
            >{{item.nowCouponList.length===0?'无可用优惠券':item.nowCouponList.length+'张可用'}}</span>
            <img :src="rightIconSrc" class="right-icon">
          </div>
        </div>

        <div class="money-row">
          <div class="money-row-left">小计</div>
          <div class="money-row-right">
            <span class="price-wra">
              ￥
              <span class="price">{{smallCount(item) | tofixed2}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-wrapper">
      <div class="total" v-cloak>
        <div class="price-wra">
          <span class="suffix">￥</span>
          <span class="price">{{totalPrice}}</span>
        </div>
      </div>
      <div class="confirm-btn" @click.stop="submit">
        <img v-if="isCostLoading" :src="loadingSrc" class="loading">
        <span v-else>确认提交</span>
      </div>
    </div>
    <coupon-modal
      type="select"
      v-if="modalCoupons"
      :data="modalCoupons"
      @select:coupon="onChooseCoupon"
      ref="couponmodal"
    ></coupon-modal>
    <van-actionsheet v-model="show" :actions="actions" cancel-text="取消" @select="onSelect"/>
    <page-guide></page-guide>
  </div>
</template>

<script>
import { _auth } from "@/js/auth";
import CouponModal from "@/components/CouponModal";
import PageGuide from "@/components/common/PageGuide";
export default {
  name: "WenChuangOrder",
  components: { CouponModal ,PageGuide},
  props: {},
  data() {
    return {
      show: false, //控制选择收货地址上拉菜单显隐
      actions: [], //选择收货地址上拉菜单内容
      addressList: [], //收货地址详细内容
      defaultAddress: null, //默认收货地址详细信息
      data: [], //商品详细内容
      chooseGoodsIndex: undefined, //当前选择优惠券的商品在this.data中的索引
      modalCoupons: [], //选择优惠券模态框当前显示的优惠券数组
      isCostLoading: false, //下单动画开关
      curSelectedCouponID: [], //当前每一个商品选择的优惠券ID
      // isShoppingCart: 0
      rightIconTransSrc: "",
      rightIconSrc: "",
      loadingSrc: "",
      token: sessionStorage.getItem("token") || ""
    };
  },
  computed: {
    encodeTel() {
      if (!this.defaultAddress) return "";
      return this.defaultAddress.phone
        .toString()
        .replace(/(\d{3})\d{4}(\d*)/, "$1****$2");
    },
    totalPrice() {
      if (!this.data || this.data.length === 0) return 0;
      let total = 0;
      this.data.forEach(e => {
        total += this.smallCount(e);
      });
      return total.toFixed(2);
    },
    isShoppingCart() {
      /** return boolean
       * 是否为直接下单
       * $route.params.type:0->直接下单 1->购物车下单
       */
      return this.$route.params.type;
    },
    longAddress() {
      return `${this.defaultAddress.province}${this.defaultAddress.city}${
        this.defaultAddress.county
      } ${this.defaultAddress.detail}`;
    }
  },
  watch: {
    $route(to, from) {
      if (!to.query.coupon) {
        this.$refs.couponmodal.closeModal();
      }
    }
  },
  created() {
    if (this.token) {
        this.getAddress();
        this.getOrderList();
    } else {
        _auth(this, () => {
            this.getAddress();
            this.getOrderList();
        });
    }
  },
  mounted() {
    this.rightIconTransSrc = API.ossUrl + "goods/png/right-icon-trans.png";
    this.rightIconSrc = API.ossUrl + "scene/png/right-icon.png";
    this.loadingSrc = API.ossUrl + "common/loading.svg";
  },
  destroyed() {},
  methods: {
    getOrderList() {
      let vm = this;
      this.$axios
        .get(`${window.API.goods.getOrderList}`, {
          params: {
            token: sessionStorage.token,
            isShoppingCart: this.isShoppingCart,
            id: sessionStorage.goodsIdList || this.$route.query.id
          }
        })
        .then(({ data }) => {
          if (data.code == 200) {
            let arrs = data.data.goodsInfo;

            if (this.isShoppingCart == 1) {
              //购物车下单填补数量
              let itemCount = JSON.parse(sessionStorage.itemCount);
              arrs.forEach((e, i, arr) => {
                arr[i].count = itemCount[e.specsId];
              });
            } else {
              arrs[0].count = 1;
            }
            //把每个优惠券计算好discount
            arrs.forEach(e => {
              e.currentDiscount = undefined; //物品选择的优惠券的discount
              e.nowCouponList = e.couponList;
              if (e.couponList.length === 0) return;
              e.couponList.forEach(coupon => {
                coupon.discount =
                  coupon.type == 1
                    ? coupon.fee
                    : e.salePrice * (1 - coupon.fee * 0.1);
              });
            });
            this.curSelectedCouponID = new Array(arrs.length).fill(undefined);
            this.data = arrs;
          } else {
            this.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    submit() {
      if (this.isCostLoading) return;
      if (this.validateInput()) {
        this.isCostLoading = true;
        this.postOrder(UTILS.callPayService);
      }
    },
    smallCount(e) {
      let each_price = e.salePrice * e.count - (e.currentDiscount || 0);
      let resolved_price = Math.ceil((each_price * 100).toFixed(4)) / 100;
      if (resolved_price < 0) resolved_price = 0;
      return resolved_price;
    },
    postOrder(cb) {
      let specsInfo = this.data.map((e, i) => {
        let tmp = {
          specsId: e.specsId,
          count: e.count
        };
        if (this.curSelectedCouponID[i])
          tmp.couponId = this.curSelectedCouponID[i];
        return tmp;
      });
      let body = {
        isShoppingCart: this.isShoppingCart,
        specsInfo,
        addressId: this.defaultAddress.id,
        totalPrice: this.totalPrice,
        payWay: ua == "wx" ? 1 : 2,
        promoteStr: localStorage.promoteStr || "",
        fromChannel: sessionStorage.fromChannel || "",
        fromPoint: sessionStorage.fromPoint || ""
      };
      if (this.isShoppingCart) {
        body.shoppingCarIds = sessionStorage.goodsCartIdList;
      }

      this.$axios
        .post(
          `${window.API.goods.postOrder}?token=${sessionStorage.token}`,
          body
        )
        .then(({ data }) => {
          if (data.code == 200) {
            localStorage.promoteStr = "";
            cb && cb(this, data.data);
          } else {
            this.isCostLoading = false;
            this.$toast(data.msg);
          }
        })
        .catch(err => {
          console.log(err);
          this.isCostLoading = false;
        });
    },
    onSelect(item) {
      let da = this.addressList.filter(e => item.id == e.id);
      this.defaultAddress = da.length > 0 ? da[0] : null;
      this.show = false;
    },
    validateInput() {
      if (!this.defaultAddress) {
        this.$alert("请选择收货地址！");
        return false;
      }
      return true;
    },
    toAddress(isAdd) {
      if (isAdd) {
        this.$router.push({
          name: "userAddressEdit",
          params: { type: 0 },
          query: { first: 0 }
        });
      } else {
        this.$router.push({ name: "userAddress" });
      }
    },
    onChooseCoupon(item) {
      this.$router.go(-1);
      let curData = this.data[this.chooseGoodsIndex];
      let couponIndex = curData.couponList.findIndex(e => item.id === e.id);
      if (
        item.type == 1 &&
        item.fee >= (curData.salePrice * curData.count).toFixed(2)
      ) {
        this.$toast("优惠券金额必须小于订单金额");
        return;
      }
      this.$set(
        this.data[this.chooseGoodsIndex],
        "currentDiscount",
        this.data[this.chooseGoodsIndex].couponList[couponIndex].discount
      );
      //吧选择的优惠券id存下来，位置对应商品index
      this.$set(this.curSelectedCouponID, this.chooseGoodsIndex, item.id);
      for (let n = 0; n < this.data.length; n++) {
        const element = this.data[n];
        this.$set(
          this.data[n],
          "nowCouponList",
          element.couponList.filter(e => {
            return this.curSelectedCouponID.indexOf(e.id) === -1;
          })
        );
      }
    },
    openCouponModal(item, index) {
      this.modalCoupons = item.nowCouponList;
      if (this.modalCoupons.length === 0) {
        this.$toast("没有更多优惠券了");
        return;
      }
      this.chooseGoodsIndex = index;
      this.$nextTick(() => {
        this.$refs.couponmodal.openModal();
        this.$router.push(`/goodsOrder/${this.$route.params.type}?coupon=1`);
      });
    },
    getAddress() {
      let vm = this;
      vm.$axios
        .get(`${window.API.user.address}?token=${sessionStorage.token}`)
        .then(({ data }) => {
          if (data.code == 200) {
            let res = data.data;
            let addedAddressId = null;
            if (Array.isArray(res) && res.length > 0) {
              addedAddressId = res[0];
            }
            vm.addressList = res;
            vm.actions = res.map(e => {
              let name = `${e.real_name} ${e.phone} ${e.province}${e.city ||
                ""}${e.county || ""}${e.addressDetail || ""}`;
              return {
                name,
                id: e.id
              };
            });
            let da = res.filter(e => e.is_default == 1);
            vm.defaultAddress = da.length > 0 ? da[0] : addedAddressId;
          } else {
            vm.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

 <style scoped lang="scss">
.goods-order-wrapper /deep/ .van-hairline--top {
  padding-left: 15px;
  text-align: left;
  &.van-actionsheet__cancel {
    text-align: center;
  }
}
.goods-order-wrapper {
  padding: 0.48rem 0.426667rem 0 0.373333rem;
  min-height: 100%;
  .address-area {
    color: $white;
    width: 100%;
    min-height: 2.32rem;
    background: linear-gradient(
      90deg,
      rgba(255, 209, 3, 1) 3%,
      rgba(247, 153, 28, 1) 100%
    );
    border-radius: 0.266667rem;
    .no-address {
      width: 100%;
      min-height: 2.32rem;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 16px;
        font-weight: bold;
      }
      img {
        width: 0.2rem;
        height: 0.4rem;
        margin-left: 0.213333rem;
      }
    }
    .address {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.533333rem 0.4rem;
      height: 100%;
      .address-left {
        color: $white;
        display: flex;
        flex-direction: column;
        max-width: 8rem;
        .big-word {
          font-size: 18px;
          margin-bottom: 0.213333rem;
          font-weight: bold;
        }
        .detail {
          font-size: 14px;
          line-height: 0.453333rem;
          @include multiple-text-overflow(3);
        }
      }
      .address-right {
        width: 0.2rem;
        height: 0.4rem;
      }
    }
  }
  .goods-area {
    margin-bottom: 1.333333rem;
    .each-goods {
      margin-top: 0.426667rem;
      background: $white;
      box-shadow: 0px 4px 16px rgba(174, 174, 174, 0.25);
      border-radius: 0.266667rem;
      .goods-display {
        padding: 0.426667rem 0;
        margin: 0 0.426667rem;
        display: flex;
        align-items: center;
        height: 3.226667rem;
        .goods-left {
          width: 2.453333rem;
          height: 2.453333rem;
          border-radius: 0.266667rem;
          box-shadow: 0px 4px 8px rgba(140, 140, 140, 0.3);
          margin-right: 0.266667rem;
          overflow: hidden;
        }
        .goods-right {
          width: 5.56rem;
          .goods-inner-top {
            color: #444444;
            font-size: 16px;
            font-weight: 500;
            // margin-bottom: 0.133333rem;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 0.533333rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            flex-direction: column;
            &.no-use {
              color: $grey4;
            }
          }
          .goods-inner-center {
            font-size: 14px;
            color: #999;
            font-weight: 400;
            line-height: 0.533333rem;
            margin-top: 0.08rem;
            margin-bottom: 0.053333rem;
            &.no-use {
              color: $grey4;
            }
          }
          .goods-inner-bottom {
            .price-wra {
              font-size: 16px;
              color: #ff9200;
              line-height: 0.586667rem;
              display: flex;
              justify-content: space-between;
              &.no-use {
                color: $grey4;
                .price {
                  color: $grey4;
                }
              }
              .pr {
                color: #aeaeae;
              }
              .price {
                font-size: 16px;
                color: #ff9200;
                font-weight: 500;
              }
            }
          }
        }
      }
      .normal-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0.333333rem;
        padding: 0 0.106667rem;
        height: 1.333333rem;
        .normal-row-left {
          color: #333333;
          font-size: 14px;
        }
        .normal-row-right {
          .right-icon {
            width: 0.16rem;
            height: 0.266667rem;
            margin-left: 0.24rem;
          }
          .coupon-price {
            font-size: 14px;
            color: $orange;
          }
          .keyong-coupon-tag {
            display: inline-block;
            @include border1px(border, $orange);
            color: $orange2;
            padding: 0.08rem 0.133333rem;
            border-radius: 1px;
          }
        }
      }

      .money-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0.426667rem;
        height: 1.28rem;
        @include border1px(border-top, $grey3);
        .money-row-left {
          color: #444444;
          font-size: 16px;
          font-weight: 500;
        }
        .money-row-right {
          .price-wra {
            color: $orange2;
            font-size: 16px;
          }
        }
      }
    }
  }
  .submit-wrapper {
    padding-left: 0.466667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 1.586667rem;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
    background: $white;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    .total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1 0 auto;
      .select-all {
        display: flex;
        align-items: center;
        img {
          width: 0.48rem;
          height: 0.48rem;
          margin-right: 0.266667rem;
        }
        span {
          font-size: 14px;
          color: #484848;
        }
      }
      .pr {
        display: flex;
        align-items: center;
      }

      .price-wra {
        margin-right: 0.266667rem;
        .suffix {
          font-size: 26px;
          color: #fe6965;
        }
        .price {
          font-size: 26px;
          color: #fe6965;
          font-weight: bold;
        }
      }
    }
    .confirm-btn {
      margin-right: 0.346667rem;
      line-height: 1.066667rem;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      color: $white;
      width: 2.96rem;
      height: 1.066667rem;
      background: linear-gradient(
        90deg,
        rgba(248, 199, 64, 1) 0%,
        rgba(245, 149, 38, 1) 100%
      );
      box-shadow: 0px 0px 12px rgba(248, 179, 86, 1);
      border-radius: 0.533333rem;
    }
  }
}
</style>

